import { pops } from './utils/popup';
pops();
